export function index(filters = false) {
    return axios.get(route('api.manage.companies.filter-groups') + (filters ? '?include=filters' : ''))
        .then(response => response.data);
}

export function items() {
    return axios.get(route('api.manage.companies.filters') + '?limit=9999')
        .then(response => response.data);
}

export function show(filterGroupId, include = []) {
    return axios.get(route('api.manage.companies.filter-groups.show',
        {
            filterGroupId: filterGroupId,
        }), {
        params: {
            include: include
        }
    }).then(response => response.data);
}

export function store(data) {
    return axios.post(route('api.manage.companies.filter-groups.store'), data)
        .then(response => response.data);
}

export function update(filterGroupId, data) {
    return axios.patch(route('api.manage.companies.filter-groups.update', {filterGroupId: filterGroupId}), data)
        .then(response => response.data);
}

export function destroy(filterGroupId) {
    return axios.delete(route('api.manage.companies.filter-groups.destroy', {filterGroupId: filterGroupId}));
}

export function duplicate(filterGroupId)
{
    return axios.post(route('api.manage.companies.filter-groups.duplicate', {filterGroupId: filterGroupId}));
}

export function storeItem(filterGroupId, data) {
    return axios.post(route('api.manage.companies.filter-groups.filters.store', {filterGroupId: filterGroupId}), data)
        .then(response => response.data);
}

export function updateItem(filterId, data) {
    return axios.patch(route('api.manage.companies.filter-groups.filters.update', {filterId: filterId}), data)
        .then(response => response.data);
}

export function destroyFilterGroup(filterId) {
    return axios.delete(route('api.manage.filters.destroy', {filterId: filterId}));
}

export function destroyItem(filterId, filterGroupId) {
    return axios.delete(route('api.manage.companies.filter-groups.filters.unlink', {
        filterId: filterId,
        filterGroupId: filterGroupId
    }))
}

export function destroyItemPermanently(filterId) {
    return axios.delete(route('api.manage.companies.filter-groups.filters.destroy', {
        filterId: filterId,
    }));
}

export function updateSortOrders(data) {
    return axios.patch(route('api.manage.companies.filter-groups.sort-order.update'), data)
        .then(response => response.data);
}

export function updateItemSortOrders(filterGroupId, data) {
    return axios.patch(route('api.manage.companies.filter-groups.filters.sort-order.update', {filterGroupId: filterGroupId}), data)
        .then(response => response.data);
}

export function ungroupedFilters() {
    return axios.get(route('api.manage.companies.filters.ungrouped'))
        .then(response => response.data);
}


export function ungroupedFiltersORM(template, templateModel, templateChildren) {
    const templates = templateModel.where((filter) => Number.isInteger(filter.id)).get();
    let filterIds = templates.map(template => template.filters.map(filter => filter.id));
    filterIds = [].concat.apply([], filterIds);

    return template[templateChildren].filter(item => !filterIds.includes(item.id));
}
